// extracted by mini-css-extract-plugin
export var container = "_g8-0";
export var content = "_g8-3";
export var customerTitle = "_g8-4";
export var empty = "_g8-5";
export var gray = "_g8-6";
export var header = "_g8-7";
export var info = "_g8-8";
export var loading = "_g8-2";
export var loadingCard = "_g8-9";
export var oneLine = "_g8-a";
export var personName = "_g8-e";
export var pillContainer = "_g8-b";
export var selected = "_g8-1";
export var text = "_g8-c";
export var twoLines = "_g8-d";
export var unread = "_g8-f";
export var unreadIndicator = "_g8-g";